const forwardRequestPanel = {
  errors: {
    loadFailed: "Ekki tókst að sækja viðtakendur",
    forwardFailed: "Ekki tókst að framsenda beiðni",
    inviteFailed: "Ekki tókst að senda boðið",
  },
  loading: "Sæki viðtakendur…",
  empty: "Engir gagnaveitendur eða verkefnisstjórar eru tiltækir til að framsenda þessa beiðni til.",
  intro:
    "Veldu einn eða fleiri viðtakendur. Hakaðu við stofnun til að velja alla meðlimi hennar, eða opnaðu hana til að velja einstaka aðila.",
  expand: {
    collapse: "Loka",
    expand: "Opna",
  },
  role: {
    pi: "Verkefnisstjóri",
    uploader: "Gagnaveitandi",
  },
  alreadyForwarded: "Þegar framsent",
  noOrganisation: "Engin stofnun",
  notesPlaceholder: "Athugasemd til viðtakanda (valfrjálst)…",
  invite: {
    heading: "Bjóða nýjum gagnaveitanda",
    emailPlaceholder: "Netfang (nauðsynlegt)",
    namePlaceholder: "Nafn (valfrjálst)",
    orgPlaceholder: "Stofnun (valfrjálst)",
    hint: "Þau fá hlekk til að hlaða inn gögnum fyrir þessa beiðni. Athugasemdin hér að ofan fylgir með í boðsbréfinu.",
    sending: "Sendi…",
    sendInvitation: "Senda boð",
    inviteSomeone: "Bjóða einhverjum sem er ekki á listanum…",
  },
  back: "Til baka",
  forward: {
    forwarding: "Framsendi…",
    forward: "Framsenda",
    forwardToCount_one: "Framsenda til {{count}} viðtakanda",
    forwardToCount_other: "Framsenda til {{count}} viðtakenda",
  },
  cancel: "Hætta við",
  selectAtLeastOne: "Veldu að minnsta kosti einn viðtakanda",
};

export default forwardRequestPanel;
